"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ARR_COLUMN_SPAN = exports.ICON = exports.COLOR = exports.SIZE = void 0;
var SIZE = {
  HEADLINE_SIZE: 'titleNormal',
  SUBHEADLINE_SIZE: 'normal',
  SUBHEADLINE_SIZE_MOB: 'small',
  ICON_SIZE: 'titleNormal',
  WITH_ICON_TEXT_LIMIT: 23,
  WITHOUT_ICON_TEXT_LIMIT: 28,
  SHOW_MORE_URL_SIZE: 'small'
};
exports.SIZE = SIZE;
var COLOR = {
  HEADLINE_COLOR: 'neutral',
  SUBHEADLINE_COLOR: 'neutral',
  SUBHEADLINE_COLOR_MOB: 'greyDark',
  ICON_COLOR: 'greyDark',
  SHOW_MORE_URL: 'secondaryBlue'
};
exports.COLOR = COLOR;
var ICON = 'ChevronRightIcon';
exports.ICON = ICON;
var ARR_COLUMN_SPAN = ['2', '3', '4'];
exports.ARR_COLUMN_SPAN = ARR_COLUMN_SPAN;